import { render } from "./EditModuloPage.vue?vue&type=template&id=0dc73f6d"
import script from "./EditModuloPage.vue?vue&type=script&lang=js"
export * from "./EditModuloPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__